import * as React from "react";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as history from "app/main/history";

export const onCerrarSesion = async () => {
    await resources.Session.set(null);
    history.go("/");
    await kea.message("Sesión cerrada", "", "success");
}


// WEBPACK FOOTER //
// ./app/logic/login.tsx